<template>
<footer id="footer" style="">
  <div id="divTotals" class="hide" onclick="$('#divTotals').hide()" style="background:rgba(50,50,0,0.30);width:100vh;height:100vh;position:fixed;top:0;left:0;z-index:1000;">
    <div class="" style="width:70%;height:140px;border-width: 1px; background:#FFF;color:#350e0f;position:fixed;top:40%;left:15%;">
      <div style="width:100%;height:35px;background:#f3e1e1;color:#350e0f;">
          <label class="pull-left title" style="margin-top:5px;margin-left:5px;">TOTAL</label>
          <button class="btn-sm pull-right link" style="background:#f3e1e1;color:#350e0f;margin-top:5px;" onclick="$('#divTotals').hide()"><i class="fa fa-times"></i></button>
      </div>
      <div style="width:100%">
          <table class="table" style="font-size:14px;">
              <tr><td style="padding:8px 2px 2px 6px;text-align:left;font-weight:bold;">Designs:</td><td style="padding:8px 8px 2px 6px;text-align:right;">{{this.results.cart.length}}</td></tr>
              <tr><td style="padding:8px 2px 2px 6px;text-align:left;font-weight:bold;">Pcs:</td><td style="padding:8px 8px 2px 6px;text-align:right;">{{CountTotalPcs()}}</td></tr>
              <tr><td style="padding:8px 2px 2px 6px;text-align:left;font-weight:bold;">Weight:</td><td style="padding:8px 8px 2px 6px;text-align:right;">{{CountTotalWeight()}}</td></tr>
          </table>
      </div>
    </div>
  </div>
  <div class="footer-bottom" style="padding: 4px 0px 2px 0px;">
    <div class="container">
      <div class="row" style="width:100%">
        <div class=" align-center" style="width:100%" v-if="$route.name == 'Cart'" >
            <div class="pull-left" style="margin-left:10px;font-size:12px;font-weight:bold;color:#1e1e1e;">
                <span class="span6">Weight: {{CountTotalWeight()}}</span>
                <span class="span6">Pcs: {{CountTotalPcs()}}</span>
                <span class="span6">Items: {{this.results.cart.length}}</span>
            </div>
            <div class="pull-right" style="margin-right:7px;">
                <button class="btn btn-default" v-on:click="$router.push('/checkout');" style="height:47px;">CHECKOUT<i style="margin-left:10px;font-weight:bold;" class="fa fa-angle-right"></i></button>
            </div>
        </div>
        <div class=" align-center" style="width:100%" v-if="$route.name == 'Checkout'" >
            <div class="pull-left" style="margin-left:10px;font-size:12px;font-weight:bold;color:#1e1e1e;">
                <span class="span6">Weight: {{CountTotalWeight()}}</span>
                <span class="span6">Pcs: {{CountTotalPcs()}}</span>
                <span class="span6">Items: {{this.results.cart.length}}</span>
            </div>
            <div class="pull-right" style="margin-right:7px;">
                <button class="btn btn-default" v-on:click="$router.push('/order-review');" style="height:47px;">CONTINUE<i style="margin-left:10px;font-weight:bold;" class="fa fa-angle-right"></i></button>
            </div>
        </div>
        <div class=" align-center" style="width:100%" v-if="$route.name == 'OrderReview'" >
            <div class="pull-left" style="margin-left:10px;font-size:12px;font-weight:bold;color:#1e1e1e;">
                <span class="span6">Weight: {{CountTotalWeight()}}</span>
                <span class="span6">Pcs: {{CountTotalPcs()}}</span>
                <span class="span6">Items: {{this.results.cart.length}}</span>
            </div>
            <div class="pull-right" style="margin-right:7px;">
                <button class="btn btn-default" v-on:click="placeOrder()" style="height:47px;">PLACE ORDER<i style="margin-left:10px;font-weight:bold;" class="fa fa-angle-right"></i></button>
            </div>
        </div>
        <div class=" align-center" style="width:100%" v-if="$route.name != 'Checkout' && $route.name != 'OrderReview' && $route.name != 'Cart'" >
          
          <button class="btn-sm btn-link footer-button" style="margin-right:0px;width:25%;" v-on:click="$router.push('/home');">
              <i class="fa fa-home" style="font-size:28px;margin:0 0 0 0;"></i><div style="font-size:10px;margin-top:-7px;"><strong>HOME</strong></div>
          </button>
          <button class="btn-sm btn-link footer-button" style="margin-right:0px;width:25%;"  v-on:click="$router.push('/cart');">
          <div class="icon pull-right circle" style="background:#f3e1e1;color:#350e0f; width:18px;height:18px;padding:0 0 0 0;margin-left:18px;margin-top:-4px;position:fixed;text-align:center;"><span class="badge" style="margin-left:-10px;margin-top:0px;position: absolute;background:#f3e1e1;color:#350e0f;">{{CountTotalPcs()}}</span></div>
              <i class="fa fa-shopping-cart" style="font-size:29px;margin:0 0 0 0;"></i><div style="font-size:10px;margin-top:-7px;"><strong>CART</strong></div>
          </button>
          <button class="btn-sm btn-link footer-button" style="margin-right:0px;width:25%;" onclick="$('#divTotals').show();">
              <div style="font-size:18px;margin:5px 0 0 0;"><strong>{{CountTotalWeight()}}</strong></div><div style="font-size:10px;margin-top:-7px;"><strong>TOTAL</strong></div>
          </button>
          <button class="btn-sm btn-link footer-button" style="margin-top:-7px;margin-right:0px;width:25%;" onclick="location.href='https://wa.me/912812229302?text=' + encodeURI('Hello!')">
              <img src="img/whatsapp.png" style="height:36px" />
          </button>
         </div>
      </div>
    </div>
  </div><!-- .footer-bottom -->
</footer>
</template>    
<script>
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
import Authentication from '@/authentication.js';
//import EventBus from '@/EventBus.js'
import $ from 'jquery'
//import { bus } from '@/main.js'

export default {
  name: 'Footer',
  props: {
    msg: String
  },data: function(){
  return {
      results: {'categories':{},'cart':{},'cart_count':'0','session':{"is_login": false,"user_id": 0,"user_name":"","company_name": "","first_name": "","last_name": "","user_type": ""}}
    }
  },created(){
    this.getSession;
    this.getCart;
},
  computed:mapGetters(["Session","Cart","CartCount","AllCategories"]),
    watch:{
    AllCategories(newValue) { this.get_response(newValue)  },
    Session(newValue) { this.get_session_response(newValue)  },
    Cart(newValue) { this.response_cart_items(newValue)  },
    CartCount(newValue) { this.results.cart_count = newValue  },
  },
  mounted(){
    this.loadSessionValues();
      //switch(this.$route.name)
      //{
      //  case "About":
      //      document.addEventListener("backbutton", this.yourCallBackFunction, false);
      //    break
      //  
      //}
    
 //     //document.addEventListener("backbutton", this.yourCallBackFunction, false);
  },
  methods:{

    ...mapActions(["removeFromCart","getCart","getSession","logoutSession"]),
    placeOrder:function()
    {
      //EventBus.$emit('placeOrder','');
      $("#btnPlaceOrder").trigger("click");
    },
    Logout:function()
    {
            this.logoutSession();
            this.$router.push("/login");
    },
    loadSessionValues:function()
    {
        this.get_response(this.AllCategories);
        this.get_session_response(this.Selection);
        this.response_cart_items(this.Cart);
        this.results.cart_count = this.CartCount;
    },
    get_response:function(response)
    {  
        //var rdata = JSON.parse(response);
        var rdata = response;
        this.results.categories = rdata;
        //this.$store.dispatch("setSession", rdata);
    },
    get_session_response:function(response)
  {	
  //var rdata = JSON.parse(response);
  var rdata = response;
  this.results.session = rdata;
  //Authentication.setSession(rdata);
  Authentication.session = rdata;

  //this.$store.dispatch("setSession", rdata);

  //EventBus.$emit('set_session', rdata);
  Common.stopAjaxLoader();
  },
  response_cart_items:function(response)
  {
      //console.log(response);
      //var rdata1 = {"cartTotal":0,"PanelTitle":title,"Rows":JSON.parse(response)}
      var rdata1 = response;
      this.results.cart = rdata1;
      Common.stopAjaxLoader();
  },CountTotalWeight:function()
  {
    var total_weight = 0;
    if(this.results.cart.length > 0){
          this.results.cart.forEach((item) => {
              total_weight = parseFloat(total_weight) + parseFloat(item.weight);
          });
    }
    return total_weight;
  },CountTotalPcs:function()
  {
    var total_Pcs = 0;
    if(this.results.cart.length > 0){
          this.results.cart.forEach((item) => {
              total_Pcs = parseFloat(total_Pcs) + parseFloat(item.qty);
          });
    }
    return total_Pcs;
  },
  response_cart:function(response)
  {
      //alert(response);
      var rdata = JSON.parse(response);
      this.results.cart_count = rdata.cart_count;
      //this.setCartItemCount(rdata.cart_count);
  }
  //,RemoveFromCart:function(e,id)
  //{
  //    //Common.callServerFunction("Cart/CartController::RemoveFromCart",this.response_cart_items,{'pid':id},"View Cart");
  //}
  //,setCartItemCount:function(item_count)
  //{
  //    //$("#divcart_item").html(item_count);
  //}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
